import axios from 'axios'
import { decryptData, encryptData } from './tweetnacl'

const CLIENT_ID = process.env.REACT_APP_SIGN_API_CLIENT_ID || null

const apiCall = async (
    method,
    url,
    data,
    headertype,
    baseurl,
    common,
    custom,
    front
) => {
    if (global.decryptData && data) {
        data = data instanceof FormData ? data : encryptData(data)
    }
    let site_url = `${global.site_url}/api/admin/`
    if (baseurl) {
        site_url = `${global.site_url}/api/admin/${baseurl}/`
    }

    if (common) {
        site_url = `${global.site_url}/api/commonFunction/`
        if (baseurl) {
            site_url = `${global.site_url}/api/commonFunction/${baseurl}/`
        }
    }

    if (custom) {
        site_url = `${global.site_url}/api/custom/`
        if (baseurl) {
            site_url = `${global.site_url}/api/custom/${baseurl}/`
        }
    }

    if (front) {
        site_url = `${global.site_url}/api/`
        if (baseurl) {
            site_url = `${global.site_url}/api/${baseurl}/`
        }
    }

    const contentType =
        headertype && headertype === 'formdata'
            ? 'multipart/form-data'
            : 'application/json'

    let headers = { 'content-type': contentType }

    const WHITELIST_KEYWORDS = ['updateProfile', 'addCompanyOwner']
    const isWhitelisted = WHITELIST_KEYWORDS.some((keyword) =>
        url.includes(keyword)
    )

    if (!isWhitelisted && CLIENT_ID && typeof CLIENT_ID !== 'undefined') {
        const [
            { default: privateKey },
            jsrsasign,
            bufferModule,
            { default: stringify },
        ] = await Promise.all([
            import('../keys/client_private'),
            import('jsrsasign'),
            import('buffer'),
            import('fast-json-stable-stringify'),
        ])

        const { KEYUTIL, KJUR } = jsrsasign
        const { Buffer } = bufferModule

        window.Buffer = Buffer
        const timestamp = Math.floor(Date.now() / 1000).toString()

        const hashObject = {
            url: site_url + url,
            method: method.toUpperCase(),
        }

        const dataToSign = timestamp + stringify(hashObject)

        try {
            const prvKey = KEYUTIL.getKey(privateKey)

            const sig = new KJUR.crypto.Signature({ alg: 'SHA256withRSA' })
            sig.init(prvKey)
            sig.updateString(dataToSign)

            const sigHex = sig.sign()
            const signatureBase64 = Buffer.from(sigHex, 'hex').toString(
                'base64'
            )

            headers['x-client-id'] = CLIENT_ID
            headers['x-signature'] = signatureBase64
            headers['x-timestamp'] = timestamp
        } catch (signErr) {
            console.error('[SIGN ERROR]', signErr)
            // Decide: continue without signature or throw
        }
    }

    const config = { headers }

    try {
        let res
        if (method === 'post') {
            res = await axios.post(`${site_url}${url}`, data || {}, config)
        } else if (method === 'get') {
            res = await axios.get(`${site_url}${url}`, config)
        } else {
            throw new Error(`Unsupported method: ${method}`)
        }

        if (global.decryptData && res.data) {
            res.data =
                data instanceof FormData ? res.data : decryptData(res.data)
        }

        return res
    } catch (err) {
        console.error('API Error:', err?.message || err)

        if (err.code === 'ECONNABORTED') {
            return {
                data: {
                    status: 'error',
                    data: {
                        message: 'Request timed out. Please try again later.',
                    },
                },
            }
        }

        if (err.response) {
            let respData = err.response.data
            if (global.decryptData && respData) {
                respData = decryptData(respData)
            }
            return {
                data: {
                    status: 'error',
                    data: {
                        message: respData?.message || 'Server Error',
                        statusCode: err.response.status,
                    },
                },
            }
        }

        return {
            data: {
                status: 'error',
                data: {
                    message: err.message || 'Something went wrong!',
                },
            },
        }
    }
}

const setAuthToken = (token) => {
    if (token) {
        axios.defaults.headers.common['authorization'] = `Bearer ${token}`
    } else {
        delete axios.defaults.headers.common['authorization']
    }
}

const setIPAddress = (ipaddress) => {
    if (ipaddress) {
        axios.defaults.headers.common['ipaddress'] = ipaddress
    } else {
        delete axios.defaults.headers.common['ipaddress']
    }
}
export { apiCall, setAuthToken, setIPAddress }
